import React from 'react';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Gallery } from '../components/Gallery';
import { HowItWorks } from '../components/HowItWorks';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-[#0A0A0A] text-[#F5F0E8] selection:bg-[#D4AF37] selection:text-black" data-id="element-76">
      <Hero data-id="element-77" />
      <Features data-id="element-78" />
      <Gallery data-id="element-79" />
      <HowItWorks data-id="element-80" />
      <Footer data-id="element-81" />
    </main>;
}